import React, {Component} from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { LittleEndian, SimAnn } from './Graphics.js';

import Navigator from './Navigator.js';

class Projects extends Component{
	constructor(props){
		super(props)
		this.state={
			bytestalkerFile: null,
			bytestalkerRes: "",
			receiptFile: null,
			receiptImg: null,
			receiptRes: "",
			receiptModal: false,
		}
		this.handleBytestalker = this.handleBytestalker.bind(this)
		this.submitBytestalker = this.submitBytestalker.bind(this)
		this.handleReceipt = this.handleReceipt.bind(this)
		this.submitReceipt = this.submitReceipt.bind(this)
	}	

	handleBytestalker(e){
		this.setState({
			bytestalkerFile: e.target.files[0]
		})
	}

	submitBytestalker(){
		if(this.state.bytestalkerFile === null){
			this.setState({
				bytestalkerRes: "Choose an ELF first"
			})
			return
		}
		fetch(
			"/api/bytestalker",
			{
				method:'POST',
				body: this.state.bytestalkerFile
			}
		)
			.then(res => res.text())
			.then((text) => {
				this.setState({
					bytestalkerRes: text
				})
			})
	}

	handleReceipt(e){
		this.setState({
			receiptFile: e.target.files[0]
		})
	}

	submitReceipt(){
		if(this.state.receiptFile === null){
			this.setState({
				receiptRes: "Choose an Image first"
			})
			return
		}
		fetch(
			"/api/receiptoverlord",
			{
				method:"POST",
				body: this.state.receiptFile
			}
		)
			.then(res => res.text())
			.then((buffer) => {
				this.setState({
					receiptRes:"",
					receiptImg: buffer
				})
			})
	}

	render(){
		let gitimg = "./images/GitHub-Mark-32px.png";
		let devimg = "./images/devpost-32.png";
		let youimg = "./images/YouTube-social-icon_red_48px.png";
		let binocular = [
			{link:"https://github.com/Veryyes/BINocular", img:gitimg, alt:"github"},
		];
		let processor = [
			{link:"https://github.com/Veryyes/E0C6S46-Ghidra-Processor", img:"./images/ghidra.png", alt:"ghidra"},
			{link:"https://github.com/Veryyes/E0C6S46-BinaryNinja-plugin", img:"./images/binja.png", alt:"binja"}
		];
		let harambe = [
			{link: "http://35.164.233.97/", img: "./images/harambe_icon.png", alt:"harambe"},
			{link: "https://github.com/Veryyes/harambe-website", img: gitimg, alt:"github"},
			{link: "https://devpost.com/software/hearts-out-for-harambe", img: devimg, alt:"devpost"}
		];

		let music = [
			{link: "https://github.com/HyperFlame1/bitcamp-2017/", img: gitimg, alt: "github"},
			{link: "https://devpost.com/software/music-in-motion-0kpcho", img: devimg, alt: "devpost"},
			{link: "https://www.youtube.com/watch?v=3UloDv5L9kk", img: youimg, alt:"youtube"}
		];

		return(	
			<div className="container">
				<Navigator />
				<main>
					<section>
						<header><h2><LittleEndian>Projects</LittleEndian></h2></header>
					</section>
					<SimAnn />
					<br/>
					<p>
						I like to build neat and fun things.
					</p>
					<hr/>
					<section>
						<Grid>
							<Row>
								<Col sm={12} md={6}>
									<div className="terminal-card project">
										<header>BINocular</header>
										<div>
											<p>BINocular is an python package for static analysis of compiled binaries through a common API layer. It is an abstraction layer between different disassemblers and provides a common set of classes (built with <a href="https://docs.pydantic.dev/latest/">Pydantic</a> and <a href="https://www.sqlalchemy.org/">SQLAlchemy</a>) to represent common binary analysis concepts such as instructions, basic blocks, and functions. BINocular currently supports Ghidra and Rizin as backend disassemblers. </p> <p> <code>pip install BINocular</code></p>
											<hr/>
											<Grid>
												<Row>
													{
														binocular.map((item, idx) => {
															return(
																<Col md={2} key={idx}>
																	<button className='btn btn-default' onClick={()=>{window.location=item.link}}>
																		<img src={item.img} alt={item.alt}/>
																	</button>
																</Col>
															)
														})
													}
												</Row>
											</Grid>
										</div>
									</div>
								</Col>
								<Col sm={12} md={6}>
									<div className="terminal-card project">
											<header>Ghidra and Binary Ninja E0C6S46 MCU Processor Module/Plugin</header>
											<div>
												<p>I wrote a processor module/plugin to disassemble ROMs from the E0C6S47 microcontroller for both Ghidra and Binary Ninja. This MCU is the one used in <a href="https://letmegooglethat.com/?q=Tamagotchi">Tamagotchis</a>. The E0C6S47 has just over 100 instructions that are 12 bits long and uses 4 bit words.</p>
												<hr/>
												<Grid>
													<Row>
														{
															processor.map((item, idx) => {
																return(
																	<Col md={2} key={idx}>
																		<button className='btn btn-default' onClick={()=>{window.location=item.link}}>
																			<img src={item.img} alt={item.alt}/>
																		</button>
																	</Col>
																)
															})
														}
													</Row>
												</Grid>
											</div>
										</div>
								</Col>
							</Row>
							<br/>
							<Row>
								<Col sm={12} md={6}>
									<div className="terminal-card project">
										<header>Hearts Out for Harambe</header>
										<div>
											<p>Gag Website created for MLH's 2016 Local Hack Day. Users can leave comments about how they remember Harambe.</p>
											<hr/>
											<Grid>
												<Row>
													{
														harambe.map((item, idx) => {
															return(
																<Col md={2} key={idx}>
																	<button className='btn btn-default' onClick={()=>{window.location=item.link}}>
																		<img src={item.img} alt={item.alt}/>
																	</button>
																</Col>
															)
														})
													}
												</Row>
											</Grid>
										</div>
									</div>
								</Col>
								<Col sm={12} md={6}>
									<div className="terminal-card project">
											<header>Music In Motion</header>
											<div>
												<p>Playing an instrument is cool; playing an invisible instrument is even cooler. Music in Motion is a project from Bitcamp, UMD annual Hackathon. It uses a <a href="https://www.ultraleap.com/product/leap-motion-controller/">Leapmotion</a> to track the cartesian coordinate positions of the figures and uses that position data to make an 'air' piano.</p>
												<hr/>
												<Grid>
													<Row>
														{
															music.map((item, idx) => {
																return(
																	<Col md={2} key={idx}>
																		<button className='btn btn-default' onClick={()=>{window.location=item.link}}>
																		<img src={item.img} alt={item.alt}/>
																	</button>
																	</Col>
																)
															})
														}
													</Row>
												</Grid>
											</div>
										</div>
								</Col>
							</Row>
						</Grid>
					</section>
				</main>
			</div>
		);
	}
}

export default Projects;
